import { useState } from "react";

import { ChevronUpIcon, ChevronDownIcon } from "lucide-react";
import Message from "../../../../../i18n/Message";

const ToolItem = ({ tool }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="tool_item" onClick={() => setExpanded(!expanded)}>
      <div className="tool_left_side">
        <div className="tool_name">{tool.name}</div>
        <div
          className={"tool_description " + (!expanded ? "line-clamp-3" : "")}
        >
          {tool.description}
        </div>
        {expanded &&
          tool.inputSchema &&
          Object.keys(tool.inputSchema.properties).length > 0 && (
            <div className="tool_params">
              <h3>
                <Message id="tool_params_title" />
              </h3>

              <div className="grid_table">
                <div class="table_header">Name</div>
                <div class="table_header">Type</div>
                <div class="table_header">Required</div>
                <div class="table_header no_right_border">Description</div>
                {Object.keys(tool.inputSchema.properties).map((propName) => {
                  const prop = tool.inputSchema.properties[propName];
                  const req = tool.inputSchema.required?.find(
                    (item) => item === propName
                  )
                    ? "yes"
                    : "no";
                  return (
                    <>
                      <div class="table_cell name">{propName}</div>
                      <div class="table_cell type">{prop.type}</div>
                      <div class="table_cell required yes">{req}</div>
                      <div class="table_cell description">
                        {prop.description}
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          )}
      </div>
      <div className="tool_right_side">
        {expanded && <ChevronUpIcon />}
        {!expanded && <ChevronDownIcon />}
      </div>
    </div>
  );
};
export default ToolItem;
